import { ModalComponent } from '../../context/ModalContext'
import ListedPanel from '../../detail/[id]/ListedPanel'
import { Services } from '../../../utils/http/Services'
import { useRequest } from 'ahooks'
import R from '../../../utils/http/request'
import { LoadingFrame } from '../common/Loading'
import styled from 'styled-components'
import Modal from './Modal'
import { IOrdItem } from '../../../lib/msigner'
import { OrderDetail } from '../../../utils/http/Services/market'

export const BuyModal: ModalComponent<boolean, { id: string }> = function (props) {
  const {
    data: ordItem,
    loading: ordLoading,
    error: ordError,
  } = useRequest(R(Services.marketService.getOrdItem, props.id), {
    cacheKey: 'getOrdItem-' + props.id,
    refreshDeps: [props.id],
  })
  const {
    data: orderDetail,
    loading: orderLoading,
    error: orderError,
  } = useRequest(R(Services.marketService.orderDetail, { inscription_id: props.id }), {
    cacheKey: 'orderDetail-' + props.id,
    refreshDeps: [props.id],
  })
  const isLoading = ordLoading || orderLoading
  const error = ordError || orderError
  if (error) {
    props.reject(error)
  }
  return (
    <StyledModal isOpen={props.isOpen} onClose={props.onClose} closeOnBackdrop closeOnEscape>
      {isLoading ? (
        <LoadingFrame size={40} center />
      ) : (
        <ListedPanel
          nftItem={ordItem as IOrdItem}
          order={orderDetail as OrderDetail}
          onBuyed={() => {
            props.resolve(true)
          }}
        />
      )}
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  width: 720px;
  position: relative;
  height: 325px;
  background-color: #1a1a1a;
`
